import { useForm } from 'react-hook-form';
import { useAlert } from 'shared/components/alerts';
import { DocumentModel } from '@types';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { useCreateSignDocumentFormSchema } from './use-create-sign-document-form-schema';
import { useSignDocument } from './use-sign-document';

export const useDocumentDialogSign = (
  documentId: string,
  onClose: () => void,
  formDataModel: DocumentModel[string]
) => {
  const { formSchema, defaultValues: dynamicDefaultValues } =
    useCreateSignDocumentFormSchema(formDataModel);
  const mutation = useSignDocument();
  const { alertError, alertSuccess } = useAlert();
  const { t } = useTranslation('hq-screen-specific');

  const methods = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      documentId,
      ...dynamicDefaultValues,
    },
  });

  const handleSubmit = methods.handleSubmit(() => {
    const { documentId, ...dynamicProperties } = methods.getValues();
    mutation.mutate(
      { documentId, dynamicProperties },
      {
        onSuccess: () => {
          alertSuccess(
            t('documents.sign_dialog.sign_success_message', { ns: 'hq-screen-specific' })
          );
          onClose();
        },
        onError: (e) => alertError(e),
      }
    );
  });

  return { methods, handleSubmit };
};
